import BaseMenu from './BaseMenu';
import BaseUISystem from '../BaseUISystem';
import { UIActions } from '../../../State/UI/UIActions';
import UITextComponent from '../../../Component/UI/Text';
import { AUDIO_UI_BUTTON_CLOSE, AUDIO_UI_BUTTON_DEFAULT } from '../../Audio';
import { GameObjectEvent } from '../../../GameObject/GameObjectEvent';
import { applyDefaultButtonAnimation } from '../UIHelper';

const BTN_CLOSE = 'main_container/close_button';
const BTN_OK = 'main_container/ok_button';
const TEXT_TITLE = 'main_container/error_title';
const TEXT_BODY = 'main_container/error_text';
const TEXT_OK = 'main_container/ok_button/ok_text';

export default class ErrorMenuHandler extends BaseMenu {
    constructor(uiSystem: BaseUISystem) {
        super('errorMenu', uiSystem);
    }

    protected onShow(params?: any): void {
        const textTitle = this.element.find(TEXT_TITLE);
        const textBody = this.element.find(TEXT_BODY);

        textTitle.getComponent(UITextComponent).text = params.title;
        textBody.getComponent(UITextComponent).text = params.body;
    }

    protected onCreate(): void {
        const btnClose = this.element.find(BTN_CLOSE);
        btnClose.on(GameObjectEvent.SELECTED, () => {
            this.system.state.dispatch(UIActions.hidePrioPopup(this.name));
        });
        applyDefaultButtonAnimation(btnClose, AUDIO_UI_BUTTON_CLOSE);

        const btnOK = this.element.find(BTN_OK);
        btnOK.on(GameObjectEvent.SELECTED, () => {
            this.system.state.dispatch(UIActions.hidePrioPopup(this.name));
        });
        applyDefaultButtonAnimation(btnOK, AUDIO_UI_BUTTON_DEFAULT);

        const btnOKText = this.element.find(TEXT_OK);
        btnOKText.getComponent(UITextComponent).text = 'OK';
    }
}
